import {Box, Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {usePatientTherapyContext} from '@/shared/contexts'
import {CumulatedDoseTable} from './tables/cumulated-dose-table'
import {EmptyState} from '@cypro/ui/components/ui/empty-state'

export function CumulatedDoseContent() {
  const {t} = useTranslate('common')
  const {cumulatedDose} = usePatientTherapyContext()

  return (
    <Tabs.Content value="cumulated_dose" spaceY="8" display="flex" flexDirection="column">
      <Box display="flex" flexDirection="column" width="100%" gap="8">
        {cumulatedDose && Object.keys(cumulatedDose).length > 0 ? (
          <CumulatedDoseTable cumulatedDoses={Object.values(cumulatedDose)} />
        ) : (
          <EmptyState title={t('cumulated.empty.title')} description={t('cumulated.empty.description')} />
        )}
      </Box>
    </Tabs.Content>
  )
}
